import * as Yup from "yup";
import IntlMessages from "components/Utils/intlMessages";
export const RegisterSchema = Yup.object().shape({
  name: Yup.string().required(<IntlMessages id="global.required" />),
  email: Yup.string().email(<IntlMessages id="global.invalidEmail" />),
  // .required(<IntlMessages id="global.required" />),
  // referral_code: Yup.string().required(<IntlMessages id="global.required" />),
  acceptTerms: Yup.bool().oneOf([true], <IntlMessages id="global.required" />),
});
